import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const EditPointUser = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Add point" }));
  const history = useHistory();
  const [nameTH, setNameTH] = useState('');
  const [nameEN, setNameEN] = useState('');
  const [point, setPoint] = useState('');
  const [descriptionTH, setDescriptionTH] = useState(' ');
  const [descriptionEN, setDescriptionEN] = useState(' ');
  const [start_date, setStart_date] = useState('');
  const [end_date, setEnd_date] = useState('');
  const [quota_member, setQuota_member] = useState('');
  const [quota_period, setQuota_period] = useState('');
  const [is_active, setIs_active] = useState('1');


  const { user } = useSelector((state) => state.auth);

  const AlertError = (message) => {
    Swal.fire("", message, "error");
  };

  const getListGroup = async () => {
    const apiUrls = `${baseURLV1}/topiclist?page=1&limit=10000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        //setListTopic(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };


  useEffect(() => {
    console.log(props)
    
  }, []);

  /*const handleChangeGroup = (event) => {
    console.log(event.target.value)
    setgroupID(event.target.value);
  };

  const handleChangeProduct = (event) => {
    console.log(event.target.value)
    setproductID(event.target.value);
  };*/

  const onSubmit = async () => {
    if (nameTH === undefined || nameTH === '') {
      return AlertError("กรุณาใส่Add point !!");
    }
    
    
    var events = {
      point: nameTH,
      tel: props.location.state.row.mobile_number
    };
 
    let apiUrls = `${baseURLV1}/participant/AddPoint`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Alert",
          "Your can not Create Event Type. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Add point"></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Add point" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <input
              number
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={nameTH}
              onChange={(e) => setNameTH(e.target.value)}
            />
          </div>

        

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/QrCode">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
